module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5135680066e1eaa3812099d39e1e73c2.png";